import { aC as a, aO as o } from "./StickyHeaderSkeleton-4367f5a1.mjs";
import { s as n, A as e } from "./Header-fa244b9a.mjs";
function y(r) {
  const {
    lang: s
  } = a();
  return n({
    url: o(e.CLIENT_V1_MY_CATEGORY),
    queryKey: [e.CLIENT_V1_MY_CATEGORY, {
      lang: s
    }],
    options: {
      suspense: !1,
      useErrorBoundary: !1,
      ...r
    }
  });
}
export {
  y as u
};
